import { useState } from "react";

import { categotiesInheaderForUserPage } from "@/utils/constants";
import UserDetailsPageInfo from "../UserDetailsPageInfo/UserDetailsPageInfo";
import UserDetailsPageAppsList from "../UserDetailsPageAppsList/UserDetailsPageAppsList";

import { ISelectedpatientProps } from "@/shared/interfaces/patientPage";

export default function UsersDetailsPageMain({
    toggleDrawer,
}: ISelectedpatientProps) {
    const [activeCategory, setActiveCategory] = useState("info");

    function renderContent() {
        switch (activeCategory) {
            case "appointments":
                return <UserDetailsPageAppsList />;
            case "info":
            default:
                return <UserDetailsPageInfo toggleDrawer={toggleDrawer} />;
        }
    }
    return (
        <main className='main_content_container'>
            <section className='header_in_main_content'>
                <div className='header_selector'>
                    {categotiesInheaderForUserPage.map(category => (
                        <p
                            key={category.id}
                            className={
                                activeCategory === category.id
                                    ? "active_category"
                                    : ""
                            }
                            id={category.id}
                            onClick={() => setActiveCategory(category.id)}
                        >
                            {category.name}
                        </p>
                    ))}
                </div>
            </section>
            {renderContent()}
        </main>
    );
}
